var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'ee-row',
      _vm.type === 'flex' ? 'ee-row--flex' : '',
      _vm.align !== 'top' ? ("is-align-" + _vm.align) : '',
      _vm.justify !== 'start' ? ("is-justify-" + _vm.justify) : ''
    ],
    style: (_vm.style)
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f42a7a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/row/Row.vue
// module id = 559
// module chunks = 13